// extracted by mini-css-extract-plugin
export default {"NanoTestPage":"NanoTestPage_NanoTestPage__cVq3N"};